const copyThroughExecCommand = async (text) => {
  if (typeof document === "undefined") {
    throw new Error("Clipboard API is not available in this context");
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

export const copyToClipboard = async (text) => {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  await copyThroughExecCommand(text);
};

export const shareLink = async ({ url, title, text }) => {
  if (!url) {
    throw new Error("shareLink requires a URL");
  }

  if (typeof navigator !== "undefined" && navigator.share) {
    await navigator.share({
      url,
      title,
      text,
    });
    return "web-share";
  }

  await copyToClipboard(url);
  return "clipboard";
};

export default {
  shareLink,
  copyToClipboard,
};
